import { TAX_RATE } from "./constants";

// turns 4900 to 49,00. 12500 to 125,00 and so on
export function formatPrice(price: number) {
  return (price / 100).toFixed(2).replace(".", ",");
}
export function getNettoPrice(price: number) {
  return price / (1 + TAX_RATE);
}
